import { MobiDocument } from './MobiDocument';

export class Ville extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private villeintitule : string;
    private codepostal : string;

    constructor(ville : any){
        super()
        this._id = ville._id;
        this._rev = ville._rev;
        this.id = ville.id;
        this.villeintitule = ville.villeintitule;
        this.codepostal = ville.codepostal;
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getVilleintitule(): string {
        return this.villeintitule;
    }

    public setVilleintitule(villeintitule: string): void {
        this.villeintitule = villeintitule;
    }

    public getCodepostal(): string {
        return this.codepostal;
    }

    public setCodepostal(codepostal: string): void {
        this.codepostal = codepostal;
    }

}